import { render, staticRenderFns } from "./ScheduleMain.vue?vue&type=template&id=24d622aa&scoped=true&"
import script from "./ScheduleMain.vue?vue&type=script&lang=js&"
export * from "./ScheduleMain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24d622aa",
  null
  
)

export default component.exports